import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./DeleteModal.css";
import { CONTAINER_WISE_COLUMN, CONTAINER_WISE_SWAP_COLUMN } from "../columns/tractorBookingColumns";
import {
  getConatinerData,
  ChangeContainerDiversion,
  Updatecontainerdiversion
} from "../../services/dataService";
import { toast } from "react-toastify";
import { filter } from "lodash";
import { TableCheckbox } from "../common/tables/TableCheckbox";
import { defaultColumn } from "../common/cells/editable/ContainerChangeModuleEditable";
import * as actionTypes from "../../store/ActionTypes";
import { dispatcher } from "../../store/storeHelpers";
import { getDailyContainerPlanningAB,getContainerswapdata,updateContainerSwapData } from "../../services/tractorDataService";
import {
  tractorDataCreatorForStore,
  aggregateDataCreatorForStore,
  fiveMDataCreatorForStore,
} from "../../utils/dataFilter";
import { CONTAINER_SWAP_ROW_DATA } from "../../store/ActionTypes";
import moment from "moment";
import { AGGREGATE_BOOKING_LOADED } from "../../store/ActionTypes";
import { FIVE_M_BOOKING_LOADED } from "../../store/ActionTypes";
import { Form } from "react-bootstrap";
import { getAggregateDailyContainerPlanning } from "../../services/aggregateDataService";
import { getFiveMDailyContainerPlanning } from "../../services/fiveMDataService";
import MainTablePaginationAdv from "./tables/MainTablePaginationAdv"
import backtick from "../../assets/svg/backtick.svg";
import store from "../../store/Store";

import {
  useTable,
  usePagination,
  useSortBy,
  useExpanded,
  useGlobalFilter,
  useRowSelect,
} from "react-table";
function ContainerCheckModule({
  show,
  hide,
  dataType,
  tableData,
  showModal,
  changeModuleData,
  checkedData,
  date,
  setData,
  step,
  setstep,
  setisloading,
  isloading,
  changeModule
}) {
  const [columns,setcolumns] = useState(CONTAINER_WISE_COLUMN);
  const [showDisableCellForJD, setShowDisableCellForJD] = useState(false);
  const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
  const [newSelectedFlatRows, setNewSelectedFlatRows] = useState([]);

  
  // const [list, setlist] = useState([]);
  const [isSelected, setIsSelected] = useState();


  var allowToEdit = filter(filteredUserAccessData, { Edit: 1 }).length > 0;

  var list=[]


  const onChanegFunc = (value,ischecked) => {
    if(!ischecked){
      list.push(value)
    
      }
      else{
        const newlist = list.filter((list)=>list!==value)
        list=newlist;
       
      }
  };
  // const checkedfunc = () => {
    
  //   list.forEach((x) => {
  //   });

  // }
  


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: tableData,
      defaultColumn,
      autoResetPage: false,
      initialState: { pageSize: 50 },
      autoResetExpanded: false,
      autoResetGlobalFilter: false,
      allowToEdit,
      tableData,
      newSelectedFlatRows,
      dataType,
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
             {/*  <TableCheckbox {...getToggleAllPageRowsSelectedProps()} /> */}
            </div>
          ),
          Cell: ({ row }) => (
            
            // showCheckbox(row) && (
            <div>
              <TableCheckbox
                {...row.getToggleRowSelectedProps()}
            
                value={row?.allCells?.[0]?.value}
                onClick={() => {
                  onChanegFunc(row?.allCells?.[0]?.value,row.getToggleRowSelectedProps().checked)
                }}
                disabled={!row.getToggleRowSelectedProps().checked && list.includes(row?.allCells?.[0]?.value)}
              />
            </div>
          ),
          // ),
        },
        ...columns,
      ]);
    }
  );
  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => {
    setNewSelectedFlatRows(selectedFlatRows);
  }, [selectedFlatRows, setNewSelectedFlatRows]);

  useEffect(()=>{
   
    if(step===1){
     setcolumns(CONTAINER_WISE_COLUMN)
    }
    else{
     setcolumns(CONTAINER_WISE_SWAP_COLUMN)
    }
 },[step])

  async function swapConatinerHandler(row) {
    if(row[0]?.original){
      try{
        dispatcher(
          CONTAINER_SWAP_ROW_DATA,
          row[0]?.original
        );
        setisloading(true)
        const payload = {
          date:row[0].original.Date,
          type:row[0].original.Module_Type ? row[0].original.Module_Type : dataType,
          screen:"DiversionTo"
        }
        const response = await getContainerswapdata(payload)
        state.pageIndex = 0
       setstep(2)
       setData(response.data)
       setisloading(false)
      }
      catch(e){
       if(e.response.data.Message){
        toast.error(e.response.data.Message)
        setisloading(false)
       }
       else{
        toast.error("Something went wrong")
        setisloading(false)
       }

      }
    }
    else if(row?.original){
      try{
        dispatcher(
          CONTAINER_SWAP_ROW_DATA,
          row?.original
        );
        setisloading(true)
        const payload = {
          date:row.original.Date,
          type:row.original.Module_Type,
          screen:"DiversionTo"
        }
        const response = await getContainerswapdata(payload)
        state.pageIndex = 0
        setstep(2)
      
     setData(response.data)
     setisloading(false)
      }
      catch(e){
        if(e.response.data.Message){
          toast.error(e.response.data.Message)
          setisloading(false)
         }
         else{
          toast.error("Something went wrong")
          setisloading(false)
         }
      }
    }
    else{
      toast.warn("No data selected")
    }
  

   /* const data = xdata.map((itemx) => {
      return itemx.original;
    });

    if (dataType === "Tractor") {
      var finalChangeData = [];
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].Booking_Number !== null) {
            finalChangeData.push({
              DailyContainerPlanningId: data[i].DailyContainerPlanningId,
              Booking_Number: data[i].Booking_Number,
              AssignContainerId: data[i].AssignContainerId,
              TransporterDataId: data[i].TransporterDataId,
              DivertedTo: data[i].Module_Type,
              PlanDate: data[i].Date,
              Market: data[i].Market,
              Type: "Tractor",
              Country: data[i].Country,
            });
          }
        }
        try {
          await ChangeContainerDiversion(finalChangeData);
          setShowChangeProcessbutton("Updating...");
          const response = await getDailyContainerPlanningAB(
            moment(date).format("YYYY-MM-DD")
          );

          dispatcher(
            TRACTOR_BOOKING_LOADED,
            tractorDataCreatorForStore(response.data.Resultset1)
          );

          toast.success("Tractor data updated");
          setShowChangeProcessbutton("Updating...");

          hide();
        } catch (error) {
          if (error.response.data.StatusCode === 404) {
            dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
            toast.success("Tractor data updated");
            // setNoDataState(true);
            hide();
          } else {
            if (error.response.data.Message === null && error.response.data.Message === "") {
              toast.error("something went wrong...please try again.");
              hide();
            } else {
              toast.error(error.response.data.Message);
            }
          }
        }
      } else {
        if (data.length === 0) {
          toast.error("Please select at least one record!");
        }
      }

    }
    if (dataType === "Aggregate") {
      var finalChangeData = [];
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
        
          if (data[i].Booking_Number !== null) {
            finalChangeData.push({
              DailyContainerPlanningId:
                data[i].DailyContainerPlanningAggregateId,
              Booking_Number: data[i].Booking_Number,
              AssignContainerId: data[i].AssignContainerAggregateId,
              TransporterDataId: data[i].TransporterDataId,
              DivertedTo: data[i].Module_Type,
              PlanDate: data[i].Date,
              Market: data[i].Market,
              Type: "Aggregate",
              Country: data[i].Country,
            });
          }
        }
        try {
          await ChangeContainerDiversion(finalChangeData);
          setShowChangeProcessbutton("Updating...");
          const response = await getAggregateDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );

          dispatcher(
            AGGREGATE_BOOKING_LOADED,
            aggregateDataCreatorForStore(response.data.Resultset1)
          );

          toast.success("Aggregate data updated");
          setShowChangeProcessbutton("Updating...");

          hide();
        } catch (error) {
          if (error.response.data.StatusCode === 404) {
            dispatcher(actionTypes.AGGREGATE_BOOKING_LOADED, []);
            toast.success("Aggregate data updated");
            // setNoDataState(true);
            hide();
          } else {
            if (error.response.data.Message === null) {
              toast.error("something went wrong...please try again.");
              hide();
            } else {
              toast.error(error.response.data.Message);
            }
          }
        }
      } else {
        if (data.length === 0) {
          toast.error("Please select at least one record!");
        }
      }

    }
    if (dataType === "5M") {
      var finalChangeData = [];
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].Booking_Number !== null) {
            finalChangeData.push({
              DailyContainerPlanningId: data[i].DailyContainerPlanning5MId,
              Booking_Number: data[i].Booking_Number,
              AssignContainerId: data[i].AssignContainer5MId,
              TransporterDataId: data[i].TransporterDataId,
              DivertedTo: data[i].Module_Type,
              PlanDate: data[i].Date,
              Market: data[i].Market,
              Type: "5M",
              Country: data[i].Country,
            });
          }
        }
        try {
          await ChangeContainerDiversion(finalChangeData);
          setShowChangeProcessbutton("Updating...");
          const response = await getFiveMDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );

          dispatcher(
            FIVE_M_BOOKING_LOADED,
            fiveMDataCreatorForStore(response.data.Resultset1)
          );

          toast.success("5M data updated");
          setShowChangeProcessbutton("Updating...");

          hide();
        } catch (error) {
          if (error.response.data.StatusCode === 404) {
            dispatcher(actionTypes.FIVE_M_BOOKING_LOADED, []);
            toast.success("5M data updated");
            // setNoDataState(true);
            hide();
          } else {
            if (error.response.data.Message === null) {
              toast.error("something went wrong...please try again.");
              hide();
            } else {
              toast.error(error.response.data.Message);
            }
          }
        }
      } else {
        if (data.length === 0) {
          toast.error("Please select at least one record!");
        }
      }
    } */
  }

const updateContainerHandler = async (row) =>{
  if(row[0]?.original){
    try{
      setisloading(true)
      const updaterow = row[0].original
      const swaprow = store.getState().daily_container_swap_row_data
      const payload = {
        "dailyContainerplanningId_frm" : swaprow.DailyContainerPlanningId,
        "assignContainerId_frm":swaprow.AssignContainerId,
        "bookingNumber_frm":swaprow.Booking_Number,
        "transporterId_frm":swaprow.TransporterDataId,
        "containerNumber_frm":swaprow.Container_Number,
        "diversionFrom":dataType,
        "dailyContainerplanningId_to":updaterow.DailyContainerPlanningId,
        "assignContainerId_to":updaterow.AssignContainerId,
        "bookingNumber_to":updaterow.Booking_Number,
        "transporterId_to":updaterow.TransporterDataId ? updaterow.TransporterDataId : 0 ,
        "containerNumber_to":updaterow.Container_Number ? updaterow.Container_Number : 0 ,
        "diversionTo":swaprow.Module_Type ? swaprow.Module_Type : dataType
      }
    const response = await updateContainerSwapData(payload)
    toast.success("Container diversion successful")
    hide();
    setTimeout(() => {
    window.location.reload();
    }, 2000);
    setisloading(false)
    }
    catch(error){
     if(error?.response?.data?.Message){
      toast.error(error.response.data.Message)
      setisloading(false)
     }
     else
     {
      toast.error("Something went wrong")
      setisloading(false)
     }
    }
  }
  else{
    toast.warn("No data selected")
  }
}

  return (
    <>
      <Modal
        show={show || showModal.status}
        centered
        dialogClassName="checkcontainer__group"
        size="sm"
      >
        <Modal.Body className="modal-body-container ">
          <div
            className="addcontainer__header"
            style={{
              width: "auto",
              height: "36px",
              position: "relative",
              top: "30px",
              left: "-26px",
              marginTop: "-30px",
            }}
          >
            
            <h5 style={{paddingLeft:step===1?"26px":"0px"}}>{step === 2 && <img src={backtick} style={{padding:"2px",cursor:"pointer"}} onClick={()=>{
              setstep(1);
              setData(store.getState().daily_container_swap_data);
            }}></img>}{step==1 ? "Container diversion details" : "Containers for diversion"}</h5>
            <button className="checkcontainer__closeBtn" onClick={hide}>
              <i class="bx bxs-x-square"></i>
            </button>
          </div>
          <div className="flex-row-align-center searchContainer">
            <Form.Control
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              className="hiden-inp"
              placeholder="search here.."
              style={{
                width: "250px",
                height: "36px",
                position: "relative",
                top: "-6px",
                // left: "-43px",

                marginTop: "-3px",
                borderTopWidth: "0px",
                right:"5px"
              }}
            />
          </div>
          <div className="table_container new-class">
            <table {...getTableProps()} className="table mtbs">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="transporter_table_class"
                      > 
                        <span
                          className="d-flex align-center"
                          style={{
                            width:
                              column.render("Header") === "TYPE" ? "150px" : "",
                          }}
                        >
                          {column.render("Header")}
                          {column.id !== "selection" && (
                            <i
                              className={
                                column.isSorted
                                  ? column.isSortedDesc
                                    ? "fi fi-rr-angle-small-down head-icon"
                                    : "fi fi-rr-angle-small-up head-icon"
                                  : "fi fi-rr-circle-small head-icon w"
                              }
                            ></i>
                          )}
                        </span>
                       
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={
                              cell.row.subRows.length !== 0
                                ? "main-row"
                                : "sub-row"
                            }
                          >
                            <div className="cell-wrap">
                              {cell.render("Cell")}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
           
          </div>
          <div style={{paddingTop:"15px",paddingRight:"30px"}}>
          <MainTablePaginationAdv
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            setPageSize={setPageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
          </div>
          
      
        </Modal.Body>

        <Modal.Footer>

        <div>
            <Button
              variant="primary"
              className="container-button"
              type="button"
              onClick={() => {
                step == 1 ? swapConatinerHandler(selectedFlatRows) : updateContainerHandler(selectedFlatRows)
              }}
              disabled={isloading}
            >
              { step==1 ? "Swap" : "Update" }
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default ContainerCheckModule;
